import React, { Component } from "react";
import DataTable from "react-data-table-component";

class Table extends Component {
  render() {
    return (
      <DataTable
        title={this.props.title}
        className={this.props.className}
        columns={this.props.columns}
        data={this.props.data}
        pagination={this.props.pagination}
        responsive={true}
        paginationPerPage={this.props.paginationPerPage}
        paginationRowsPerPageOptions={this.props.paginationRowsPerPageOptions}
      />
    );
  }
}

export default Table;
